export async function getList({ /*token,*/ uid, prjId, fromDt, toDt }) {
    const url = 'https://reports.imon.gulfnet-cloud.com/v1/logs';
    const params = { /*token: token,*/ uid: uid, prjId:prjId, fromDt: fromDt.toISOString(), toDt: toDt.toISOString() };
    const query_params = new URLSearchParams(params);
    const init_params = {
        credentials: "same-origin"
    }
    const res = await fetch(url + '?' + query_params, init_params);
    //const results = JSON.parse(await res.json());
    const results = res.json();
    
    let logsData = {batchLogs:[],maintLogs:[],pgLogs:[],alertLogs:[]};
    logsData['fromDt'] = Date.parse(results.fromDt);  // ToDo: parse check
    logsData['toDt'] = Date.parse(results.toDt);  // ToDo: parse check
    logsData.batchLogs = logsData.batch_log; //batch_log_error
    logsData.maintLogs = logsData.maint_log; //log_alert:maint_log
    logsData.checkLogs = logsData.check_log; //log_alert:check_log
    logsData.pgLogs = logsData.postgres_log; //log_alert:postgres_log
    return logsData;
}
